<div
	#content
	[ngClass]="{
		'line-clamp-6 md:line-clamp-4': !expanded(),
	}"
>
	<ng-content />
</div>
@if (showToggle()) {
	<button
		(click)="toggle()"
		class="mt-2 text-link"
		data-test-id="toggle-read-more"
	>
		{{ (expanded() ? 'global.read-less' : 'global.read-more') | translate }}
	</button>
}
